var window=global;var $CLJS=require("./cljs_env");require("./goog.base.js");
a:{var Ba=$CLJS.ea.navigator;if(Ba){var Ea=Ba.userAgent;if(Ea){$CLJS.Aa=Ea;break a}}$CLJS.Aa=""};